const COUNTRIES_DATA = {
    uae: {
        id: 1,
        name: 'United Arab Emirates',
        isoCode: 'AE',
        phoneCode: '971',
        currency: 'AED',
        nationalIdLabel: 'Emirates ID',
        rcLabel: 'MULKIYA',
        division: { id: '4', name: 'Dubai', code: 'DXB' },
        jeCompany: 'Openfr8',
    },
    ksa: {
        id: 2,
        name: 'Saudi Arabia',
        isoCode: 'SA',
        phoneCode: '966',
        currency: 'SAR',
        nationalIdLabel: 'National ID / IQAMA',
        rcLabel: 'ISTIMARA',
        division: { id: '12', name: 'KSA', code: 'KSA' },
        jeCompany: 'Saudi',
    },
    omn: {
        id: 3,
        name: 'Oman',
        isoCode: 'OM',
        phoneCode: '968',
        currency: 'OMR',
        nationalIdLabel: 'Civil ID',
        rcLabel: 'MULKIYA',
        division: { id: '9', name: 'Oman', code: 'MCT' },
        jeCompany: 'Oman',
    },
} as const

type CountryKey = keyof typeof COUNTRIES_DATA

function mapCountries<T>(fn: (data: (typeof COUNTRIES_DATA)[CountryKey]) => T): Record<CountryKey, T> {
    return Object.fromEntries(
        (Object.keys(COUNTRIES_DATA) as CountryKey[]).map((key) => [key, fn(COUNTRIES_DATA[key])])
    ) as Record<CountryKey, T>
}

export const country = {
    COUNTRIES: Object.keys(COUNTRIES_DATA) as string[],
    COUNTRY: { UAE: 'uae', KSA: 'ksa', OMAN: 'omn' } as const,
    COUNTRY_CODE: mapCountries((d) => d.phoneCode),
    COUNTRY_NAME: mapCountries((d) => d.name),
    ISO_CODE: mapCountries((d) => d.isoCode),
    CURRENCY: mapCountries((d) => d.currency),
    DEFAULT_CURRENCY: 'AED ',
    NATIONALID_LABEL: mapCountries((d) => d.nationalIdLabel),
    DOCUMENT_LABELS: mapCountries((d) => ({ EMIRATES_ID: d.nationalIdLabel, RC: d.rcLabel })),
    COUNTRY_DIVISION: mapCountries((d) => d.division),
    BASIC_DETAIL: mapCountries((d) => ({ id: d.id, name: d.name, code: d.phoneCode })),
    JE_COMPANY: mapCountries((d) => d.jeCompany),
}
